import { APP_NAME } from '#/utils/constants';

import type { DefinitionTerm } from './lib';

/** Shared disclosure content for the drawer and page footer. */
export const disclosureStatement = {
  slug: 'disclosure-statement',
  name: 'Disclosure Statement',
  tooltip: null,
  description: null,
  expandedDefinition: `<p>The data and other information available on the ${APP_NAME} is compiled
from multiple sources and is provided for the convenience of site
visitors. FINRA and its information providers do not guarantee the
accuracy, completeness or timeliness of the information, and therefore,
site visitors should not make investment or other financial decisions
solely on the basis of this information. Additional information and
disclaimers about information provided by third parties may be found
<a href="https://finra.org/mdie-disclaimer" target="_blank" rel="noopener noreferrer" class="underline underline-offset-2">here</a>.</p>`,
} satisfies DefinitionTerm;
